// extracted by mini-css-extract-plugin
export default {"container":"style_container__h2Bnb","content":"style_content__H+lFn","title":"style_title__eeJl8","title_header":"style_title_header__rLOGL","title_inner":"style_title_inner__RcQ4P"};